/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "one-way-exchange-unread",

    getDefaultProps: function getDefaultProps() {
        return {
            "oneWayExchangeUnread": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "77.9",
            "height": "70.6"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 77.9 70.6", className: "one-way-exchange-unread", width: this.props.width, height: this.props.height, style: this.props.oneWayExchangeUnread },
            _react2["default"].createElement("path", { fill: "#367C2B", d: "M57.7 57.3v13.3l20.2-20.1-20.2-20.2v13.3H35v13.7zM22.6 45.2L0 22.6 22.6 0v14.7h22.8v15.7H22.6v14.8zM2.8 22.6l17.8 17.8V28.5h22.8V16.7H20.6V4.8L2.8 22.6z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/one-way-exchange-unread.js